import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';
import { getOneClickPreloadedOrder } from '../selectors/one-click-profiles.selector';

export const getOneClickPointOfDeliveryState = createSelector(
  getOneClickState,
  state => state.pointOfDeliveriesState,
);

export const getOneClickSelectedPointOfDelivery = createSelector(
  getOneClickPointOfDeliveryState,
  state => state.selected,
);

export const getOneClickPointOfDeliveries = createSelector(
  getOneClickPointOfDeliveryState,
  state => state.pointOfDeliveriesAvailable,
);

export const podsWithPreloaded = createSelector(
  getOneClickPointOfDeliveries,
  getOneClickPreloadedOrder,
  (pods, preloadedOrder) => ({ pods, preloadedOrder }),
);
